import { Modal } from "antd";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Utilities from "../../dependencies/custom/react-utilities";

const SessionExpiredModal = ({ open, onClose }) => {
  const navigate = useNavigate();

  const handleOk = () => {
    onClose();
    Utilities.stopTokenRefreshTimer();
    Utilities.logout(navigate, "access", "refresh", "../signin");
  };

  return (
    <Modal
      open={open}
      title={
        <span>
          <ExclamationCircleFilled
            style={{ color: "#ff4d4f", marginRight: 8, fontSize: 20 }}
          />
          Alert
        </span>
      }
      closable={false}
      maskClosable={false}
      keyboard={false}
      cancelButtonProps={{ style: { display: "none" } }}
      okText="OK"
      onOk={handleOk}
      centered
    >
      <p style={{ marginLeft: 28, marginBottom: 0 }}>
        You're logged out of your account due to inactivity. Please login again.
      </p>
    </Modal>
  );
};

export default SessionExpiredModal;
